import { Link } from "react-router";
import logoFooterSIA from "@assets/events-awards/sia/logo-footer-sia.png";
import FooterMenuLinks from "@events-awards/components/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SIA_PATH } from "@events-awards/utils/constants";
import { SIA_FOOTER_MENU } from "@sia/utils/constants";

/**
 * Component to display footer for mobile view in SIA pages
 */
const SIAFooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full text-center"
      data-testid="sia-footer-mobile-component"
    >
      <div className="mb-6 flex w-full flex-col items-center justify-center">
        <Link to={EVENTS_AWARDS_SIA_PATH} reloadDocument>
          <img
            src={logoFooterSIA}
            alt="SIA Awards logo"
            width={200}
            height={61}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-4 text-left font-poppins text-lg font-semibold">
          About Us
        </h3>

        <div className="text-left text-sm text-white">
          <p>
            The Sustainability Impact Awards (SI Awards), launched on 1 February
            2023, is jointly presented by The Business Times and UOB, with the
            Centre for Governance and Sustainability (CGS) at the National
            University of Singapore Business School as the knowledge partner.
          </p>
        </div>
      </div>

      <div className="-mx-0 mt-6 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-lg font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={SIA_FOOTER_MENU.slice(0, 5)}
            linkClassName="text-sm"
          />
        </div>

        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-lg font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks
            items={SIA_FOOTER_MENU.slice(5, 8)}
            linkClassName="text-sm"
          />
        </div>
      </div>
    </div>
  );
};

export default SIAFooterMobile;
